import { Component, OnInit, AfterViewInit, ChangeDetectorRef, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { AuthenticationService } from '../../../services/security';
// Parité V1 : CookieService (ngx-cookie-service) était injecté mais jamais utilisé
// (aucun appel this.cookieService.* dans le composant) — injection supprimée car le
// paquet ngx-cookie-service n'est pas installé en V2. Aucun impact comportemental.
import { AppConsts } from '../../../shared/app-consts';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu-v2.component.html',
  styleUrls: ['./nav-menu.component.css', './nav-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false
})
export class NavMenuComponent implements OnInit {
  slidMenuVisible = false;
  accountMenuVisible = false;
  userName: string = null;
  currentEmail: string;
  settingMenuVisible = false;
  fullName: string;
  isExternalLogin: boolean = false;
  externalUserEmail: string = null;
  @Output() isfullscreen : EventEmitter<boolean> = new EventEmitter();

  constructor(private router: Router, private authService: AuthenticationService) { }

  ngOnInit() {
    this.authService.authenticationState.subscribe(() => {
      this.loadConnectedUser();
    });

    this.authService.externalUserInfo.subscribe(info => {
      this.isExternalLogin = info.isExternal;
      this.externalUserEmail = info.externalEmail;
    });

    // Charger immédiatement si déjà authentifié
    this.loadConnectedUser();
  }

  loadConnectedUser() {
    if (this.authService.IsAuthenticated()) {
      var jwtToken = JSON.parse(sessionStorage.getItem(AppConsts.TOKEN_KEY));
      this.userName = jwtToken.UserName || jwtToken.UserEMail || jwtToken.Email || 'Utilisateur';
      this.fullName = jwtToken.FullName || jwtToken.UserEMail || jwtToken.Email || 'Utilisateur';
      this.currentEmail = jwtToken.UserEMail || jwtToken.Email || sessionStorage.getItem(AppConsts.USER_MAIL) || '';

      // Restaurer les infos de connexion externe depuis sessionStorage
      const externalEmail = sessionStorage.getItem('external_user_email');
      if (externalEmail) {
        this.isExternalLogin = true;
        this.externalUserEmail = externalEmail;
        // Mettre à jour le BehaviorSubject pour synchroniser avec d'autres composants
        this.authService.externalUserInfo.next({isExternal: true, externalEmail: externalEmail});
      }
    }
  }

  isFullScreen: boolean = false;

  showSideBar() {
    this.slidMenuVisible = true;
  }
  showOrNotFullScreen(){
    this.isFullScreen = !this.isFullScreen;
    this.isfullscreen.next(this.isFullScreen);
  }
  showAccountMenu() {
    this.accountMenuVisible = true;
  }
  showSettingBar(){
    this.settingMenuVisible = true;
  }

  onSideBarClose() {
    this.slidMenuVisible = false;
  }

  onSettingBarClose() {
    this.settingMenuVisible = false;
  }
}
